import React, { useState, useEffect, useMemo } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
// import { useNavigate } from "react-router-dom";

//API
import ItemService from "../../../../services/supplier_appCommonService";
// import ItemServiceV2 from "../../../../services/customer_appCommonService";
import CustomerService from "../../../../services/customer_v2_appCommonService";

//Redux
import { useSelector, useDispatch } from "react-redux";
import {
  getPurchaseOrder,
  getSchedulingAgreement,
  getServicePO,
} from "../../../../redux/feature/supplier_app/purchasingSlice";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import HeaderText from "../../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
// import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/CustomerConstants";
import {
  getCurrentDate,
  isValidNumber,
  validateRequired,
} from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
// import SericesSchedulePO from "../../../../Components/Modal/supplier_app/PO_Collabration/SericesSchedulePO";
import Loader from "../../../../Components/Loader";
import MaterialSelectionModalV5 from "./MaterialSelectionModalV5";
import SericesSchedulePOV5Modal from "./SericesSchedulePOV5Modal";
import UpdateRemarksModal from "../Common/UpdateRemarksModal";
// import TableDropdownMenu from "../../../../Components/TableDropdownMenu/TableDropdownMenu";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";

const POUpdateV5 = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Purchase Order");

  // eslint-disable-next-line
  let purchaseDocCode = useSelector(
    (state) => state?.purchasing.purchaseDocCode,
  );
  // eslint-disable-next-line
  let userData = useSelector((state) => state?.user); // User Details from Store

  let poNumber = useSelector(
    (state) => state?.purchasing?.purchase_order?.poNumber,
  );
  const [editMode, setEditMode] = useState(true);
  // eslint-disable-next-line
  const [currentDate] = useState(getCurrentDate("default"));

  const [formInputs, setFormInputs] = useState({});
  const [updateModalShow, setUpdateModalShow] = useState(false);
  const [getCurrencyDropdown, setCurrencyDropdown] = useState([]);
  // eslint-disable-next-line
  const [getLoader, setLoader] = useState();

  let getPurchaseOrderType = [
    {
      id: "1",
      name: "Packing/Promotional",
      code: "PA",
      description: "Packing/Promotional",
    },
    {
      id: "2",
      name: "Trade",
      code: "TR",
      description: "Trade",
    },
    {
      id: "3",
      name: "Factory",
      code: "FA",
      description: "Factory",
    },
    {
      id: "4",
      name: "Consumable",
      code: "CO",
      description: "Consumable",
    },
    {
      id: "5",
      name: "Repairing",
      code: "RE",
      description: "Repairing",
    },
    {
      id: "6",
      name: "Asset",
      code: "AS",
      description: "Asset",
    },

    {
      id: "7",
      name: "BuyBack",
      code: "BU",
      description: "BuyBack",
    },
    {
      id: "8",
      name: "Packaging",
      code: "PA",
      description: "Packaging",
    },
    {
      id: "9",
      name: "Factory-Label",
      code: "FL",
      description: "Factory-Label",
    },
    {
      id: "10",
      name: "Business-Logistics",
      code: "BL",
      description: "Business-Logistics",
    },
    {
      id: "11",
      name: "Development-Samples",
      code: "DS",
      description: "Development-Samples",
    },
    {
      id: "12",
      name: "Job Work",
      code: "JW",
      description: "Job Work",
    },
    {
      id: "13",
      name: "Development-Services",
      code: "DS",
      description: "Development-Services",
    },
    {
      id: "14",
      name: "Outservice",
      code: "OS",
      description: "Outservice",
    },
  ];

  const modalData = {
    title: "PO Creation",
    successMsg: "",
  };
  // eslint-disable-next-line
  const storageLocationData = [
    { id: 1, name: "Sale", code: "SL", description: "Sale" },
    { id: 2, name: "Rent", code: "RE", description: "Rent" },
  ];

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // eslint-disable-next-line
  const handleDropdownChange = (data) => {
    setPOLineItemsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === data.index
          ? {
              ...row,
              [data.name]: data.value,
              [data.code]: data.codeValue,
              [data.desc]: data.descValue,
            }
          : row,
      ),
    );
  };

  // Inital Create PO
  const POLineItemInitialCol = useMemo(
    () => [
      {
        name: "Document Item Nr",
        selector: (row) => row.local_id || "--",
        sortable: false,
        width: "180px",
      },
      /*  {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: false,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    }, */
      {
        name: "Material/Service",
        selector: (row) => row.materialCode || "--",
        cell: (row) => (
          // <InputField
          //   className="inputBox mt-1"
          //   // label="Please Enter the Remarks*"
          //   name="materialCode"
          //   placeholder=""
          //   value={row.materialCode || ""}
          //   onChange={(event) => handleInputChange(row.local_id, event)}
          //   disabled={true}
          // />
          <InputField
            className="inputBox mt-1"
            name="materialCode"
            placeholder=""
            value={row.materialCode || ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
            // disabled={!row.isManual} // ← enabled only for manual rows
            disabled={editMode || !row.isManual}
          />
        ),
        sortable: false,
        width: "200px",
      },
      {
        name: "Description",
        selector: (row) => row.materialDescription || "--",
        cell: (row) => (
          <TextAreaField
            className="inputBox mt-1"
            name="materialDescription"
            placeholder=""
            value={row.materialDescription || ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
            disabled={editMode}
          />
        ),
        sortable: false,
        width: "200px",
      },
      /* {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: false,
      width: "200px",
    }, */
      {
        name: "Quantity ",
        selector: (row) => row.purchaseQuantity || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="purchaseQuantity"
            placeholder=""
            value={row.purchaseQuantity || ""}
            onChange={(event) =>
              handleInputChange(row.local_id, event, "Number")
            }
            disabled={editMode}
          />
        ),
        sortable: false,
        width: "200px",
      },
      {
        name: "UOM ",
        selector: (row) => row.orderUnitOfMeasure || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="orderUnitOfMeasure"
            placeholder=""
            value={row?.unit || row.orderUnitOfMeasure || ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
            disabled={true}
          />
        ),
        width: "200px",
      },
      {
        name: "Unit Price ",
        selector: (row) => row.orderPriceUnit || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            // label="Please Enter the Remarks*"
            name="orderPriceUnit"
            placeholder=""
            value={row?.unitPrice || row.orderPriceUnit || ""}
            onChange={(event) =>
              handleInputChange(row.local_id, event, "Number", "UNITPRICE")
            }
            // disabled={!row.isManual}
            // disabled={editMode}
            disabled={editMode || !row.isManual}
          />
        ),
        width: "200px",
      },
      {
        name: "Item Value ",
        selector: (row) => row.netValue || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="netValue"
            placeholder=""
            value={row.netValue || 0}
            disabled={true}
          />
        ),
        width: "130px",
      },
      {
        name: "Currency",
        selector: (row) => row.currencyCode || "INR",
        width: "130px",
      },
      {
        name: "GST Amount",
        selector: (row) => row.taxAmount || "--",
        cell: (row) => (
          // <InputField
          //   className="inputBox mt-1"
          //   name="taxAmount"
          //   placeholder=""
          //   // value={Math.round(row.taxAmount).toFixed(2) || 0}
          //   value={row.taxAmount || 0}
          //   disabled={true}
          // />
          <InputField
            className="inputBox mt-1"
            name="taxAmount"
            placeholder=""
            value={row.taxAmount || 0}
            onChange={(event) =>
              handleInputChange(row.local_id, event, "Number")
            }
            // disabled={!row.isManual}
            disabled={true}
          />
        ),
        sortable: false,
        width: "200px",
      },
      {
        name: "GST Code % ",
        selector: (row) => row.taxCode || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            name="taxCode"
            placeholder=""
            value={row.taxCode}
            onChange={(event) =>
              handleInputChange(row.local_id, event, "Number", "VAT")
            }
            disabled={editMode}
          />
        ),
        sortable: false,
        width: "200px",
      },
      {
        name: "Delivery Date",
        selector: (row) => row.deliveryDate || "--",
        cell: (row) => (
          // <InputField
          //   className="inputBox mt-1"
          //   type="date"
          //   name="deliveryDate"
          //   placeholder=""
          //   value={row.deliveryDate || ""}
          //   onChange={(event) => handleInputChange(row.local_id, event)}
          // />
          <InputField
            className="inputBox mt-1"
            type="date"
            name="deliveryDate"
            placeholder=""
            value={row.deliveryDate || ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
            disabled={editMode}
          />
        ),
        width: "200px",
      },
      // {
      //   name: "Plant",
      //   selector: (row) => row.plant || "--",
      //   cell: (row) => (
      //     <InputField
      //       className="inputBox mt-1"
      //       // label="Please Enter the Remarks*"
      //       name="plant"
      //       placeholder=""
      //       value={row.plant || ""}
      //       onChange={(event) => handleInputChange(row.local_id, event)}
      //     />
      //   ),
      //   sortable: false,
      //   width: "200px",
      // },
      {
        name: "Godown",
        selector: (row) => row.storageLocation || "--",
        cell: (row) => (
          <div>
            <p className="m-0 p-0">{row?.storageLocation}</p>
          </div>

          // <TableDropdownMenu
          //   index={row?.local_id}
          //   label={"Godown"}
          //   data={storageLocationData}
          //   id={"storageLocation"}
          //   name={"storageLocation"}
          //   code={"storageLocationCode"}
          //   description={"storageLocationDescription"}
          //   onChange={handleDropdownChange}
          //   value={row?.storageLocation}
          //   codeValue={row?.storageLocationCode}
          //   descValue={row?.storageLocationDescription}
          //   // required={true}
          // />
        ),
        sortable: false,
        width: "200px",
      },
      {
        name: "Delete",
        selector: (row) => row.local_id || "--",
        sortable: false,
        cell: (row) => (
          <button
            className="btn btn-danger"
            onClick={() => removePOItemRow(row.local_id)}
            disabled={editMode}
          >
            <i className="bi bi-trash3"></i>
          </button>
        ),
        width: "120px",
      },
    ],
    // eslint-disable-next-line
    [editMode],
  );

  useEffect(() => {
    setPOLineItemsCol(POLineItemInitialCol);
  }, [POLineItemInitialCol]);
  // let POLineItemInitialCol = [
  //   {
  //     name: "Document Item Nr",
  //     selector: (row) => row.local_id || "--",
  //     sortable: false,
  //     width: "180px",
  //   },
  //   /*  {
  //     name: "Item Text",
  //     selector: (row) => row.local_id || "--",
  //     sortable: false,
  //     width: "110px",
  //     cell: (row) => (
  //       <>
  //         <span
  //           style={{ marginLeft: "12px" }}
  //           onClick={() =>
  //             showLineItemHeaderText(row.local_id, row.itemTextData)
  //           }
  //         >
  //           <i className="bi bi-calendar2-week iconTable"></i>
  //         </span>
  //         <span className="suppliersIcon">
  //           {" "}
  //           {row.itemTextData?.length || 0}{" "}
  //         </span>
  //       </>
  //     ),
  //   }, */
  //   {
  //     name: "Material/Service",
  //     selector: (row) => row.materialCode || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         // label="Please Enter the Remarks*"
  //         name="materialCode"
  //         placeholder=""
  //         value={row.materialCode || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event)}
  //         disabled={true}
  //       />
  //     ),
  //     sortable: false,
  //     width: "200px",
  //   },
  //   {
  //     name: "Description",
  //     selector: (row) => row.materialDescription || "--",
  //     cell: (row) => (
  //       <TextAreaField
  //         className="inputBox mt-1"
  //         name="materialDescription"
  //         placeholder=""
  //         value={row.materialDescription || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event)}
  //         disabled={editMode}
  //       />
  //     ),
  //     sortable: false,
  //     width: "200px",
  //   },
  //   /* {
  //     name: "Material Group ",
  //     selector: (row) => row.materialGroup || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         // label="Please Enter the Remarks*"
  //         name="materialGroup"
  //         placeholder=""
  //         value={row.materialGroup || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event)}
  //       />
  //     ),
  //     sortable: false,
  //     width: "200px",
  //   }, */
  //   {
  //     name: "Quantity ",
  //     selector: (row) => row.purchaseQuantity || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="purchaseQuantity"
  //         placeholder=""
  //         value={row.purchaseQuantity || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event, "Number")}
  //         disabled={editMode}
  //       />
  //     ),
  //     sortable: false,
  //     width: "200px",
  //   },
  //   {
  //     name: "UOM ",
  //     selector: (row) => row.orderUnitOfMeasure || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="orderUnitOfMeasure"
  //         placeholder=""
  //         value={row.orderUnitOfMeasure || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event)}
  //         disabled={editMode}
  //       />
  //     ),
  //     width: "200px",
  //   },
  //   {
  //     name: "Unit Price ",
  //     selector: (row) => row.orderPriceUnit || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         // label="Please Enter the Remarks*"
  //         name="orderPriceUnit"
  //         placeholder=""
  //         value={row.orderPriceUnit || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event, "Number")}
  //         disabled={editMode}
  //       />
  //     ),
  //     width: "200px",
  //   },
  //   {
  //     name: "Item Value ",
  //     selector: (row) => row.netValue || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="netValue"
  //         placeholder=""
  //         value={row.netValue || 0}
  //         disabled={true}
  //       />
  //     ),
  //     width: "130px",
  //   },
  //   {
  //     name: "Currency",
  //     selector: (row) => row.currencyCode || "INR",
  //     width: "130px",
  //   },
  //   {
  //     name: "GST Amount",
  //     selector: (row) => row.taxAmount || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="taxAmount"
  //         placeholder=""
  //         value={row.taxAmount || 0}
  //         disabled={true}
  //       />
  //     ),
  //     sortable: false,
  //     width: "200px",
  //   },
  //   {
  //     name: "GST Code % ",
  //     selector: (row) => row.taxCode || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="taxCode"
  //         placeholder=""
  //         value={row.taxCode}
  //         onChange={(event) =>
  //           handleInputChange(row.local_id, event, "Number", "VAT")
  //         }
  //         disabled={editMode}
  //       />
  //     ),
  //     sortable: false,
  //     width: "200px",
  //   },
  //   {
  //     name: "Delivery Date",
  //     selector: (row) => row.deliveryDate || "--",
  //     cell: (row) => (
  //       // <InputField
  //       //   className="inputBox mt-1"
  //       //   type="date"
  //       //   name="deliveryDate"
  //       //   placeholder=""
  //       //   value={row.deliveryDate || ""}
  //       //   onChange={(event) => handleInputChange(row.local_id, event)}
  //       // />
  //       <InputField
  //         className="inputBox mt-1"
  //         type="date"
  //         name="deliveryDate"
  //         placeholder=""
  //         value={row.deliveryDate || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event)}
  //         disabled={editMode}
  //       />
  //     ),
  //     width: "200px",
  //   },
  //   // {
  //   //   name: "Plant",
  //   //   selector: (row) => row.plant || "--",
  //   //   cell: (row) => (
  //   //     <InputField
  //   //       className="inputBox mt-1"
  //   //       // label="Please Enter the Remarks*"
  //   //       name="plant"
  //   //       placeholder=""
  //   //       value={row.plant || ""}
  //   //       onChange={(event) => handleInputChange(row.local_id, event)}
  //   //     />
  //   //   ),
  //   //   sortable: false,
  //   //   width: "200px",
  //   // },
  //   {
  //     name: "Storage Location",
  //     selector: (row) => row.storageLocn || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         // label="Please Enter the Remarks*"
  //         name="storageLocn"
  //         placeholder=""
  //         value={row.storageLocn || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event)}
  //         disabled={editMode}
  //       />
  //     ),
  //     sortable: false,
  //     width: "200px",
  //   },
  //   {
  //     name: "Delete",
  //     selector: (row) => row.local_id || "--",
  //     sortable: false,
  //     cell: (row) => (
  //       <button
  //         className="btn btn-danger"
  //         onClick={() => removePOItemRow(row.local_id)}
  //         disabled={editMode}
  //       >
  //         <i className="bi bi-trash3"></i>
  //       </button>
  //     ),
  //     width: "120px",
  //   },
  // ];

  let POLineItemInitialData = [
    // {
    //   local_id: 1,
    //   purchasingDocumentItemNr: 1,
    //   itemTextData: [],
    //   statusItem: "In Release",
    //   currency: getCurrencyDropdown.name || "Rupee",
    //   currencyCode: getCurrencyDropdown.code || "INR",
    //   taxCode: 0,
    //   taxAmount: 0,
    // },
  ];

  // Inital Create Service PO
  let ServicePOLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: false,
      width: "180px",
    },
    /*   {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: false,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    }, */
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   // label="Please Enter the Remarks*"
        //   name="materialCode"
        //   placeholder=""
        //   value={row.materialCode || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        //   disabled={true}
        // />
        <InputField
          className="inputBox mt-1"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={!row.isManual} // ← enabled only for manual rows
        />
      ),
      sortable: false,
      width: "200px",
    },
    {
      name: "Service",
      selector: (row) => row.local_id || "--",
      sortable: false,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServicesLineItem(row.local_id, row.services, "SER")
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.services?.length || 0} </span>
        </>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: false,
      width: "200px",
    },
    /*  {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: false,
      width: "200px",
    }, */
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: false,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   name="netValue"
        //   placeholder=""
        //   value={row.netValue || 0}
        //   disabled={true}
        // />
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
          disabled={!row.isManual} // ← enabled only for manual rows
        />
      ),
      width: "130px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "130px",
    },
    {
      name: "GST Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   name="taxAmount"
        //   placeholder=""
        //   value={row.taxAmount || 0}
        //   disabled={true}
        // />
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount || 0}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
          disabled={true}
        />
      ),
      sortable: false,
      width: "200px",
    },
    {
      name: "GST Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: false,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    // {
    //   name: "Plant",
    //   selector: (row) => row.plant || "--",
    //   cell: (row) => (
    //     <InputField
    //       className="inputBox mt-1"
    //       // label="Please Enter the Remarks*"
    //       name="plant"
    //       placeholder=""
    //       value={row.plant || ""}
    //       onChange={(event) => handleInputChange(row.local_id, event)}
    //     />
    //   ),
    //   sortable: false,
    //   width: "200px",
    // },
    {
      name: "Godown",
      selector: (row) => row.storageLocation || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.storageLocation}</p>
        </div>
        // <InputField
        //   className="inputBox mt-1"
        //   // label="Please Enter the Remarks*"
        //   name="storageLocn"
        //   placeholder=""
        //   value={row.storageLocn || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        // />
      ),
      sortable: false,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: false,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let ServicePOLineItemInitialData = [
    /* {
      local_id: 1,
      purchasingDocumentItemNr: 1,
      itemTextData: [],
      statusItem: "In Release",
      currency: getCurrencyDropdown.name || "Rupee",
      currencyCode: getCurrencyDropdown.code || "INR",
      taxCode: 0,
      taxAmount: 0,
    }, */
  ];

  // Inital Create Schedule PO
  let SchedulePOLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: false,
      width: "180px",
    },
    /*   {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: false,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    }, */
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   // label="Please Enter the Remarks*"
        //   name="materialCode"
        //   placeholder=""
        //   value={row.materialCode || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        //   disabled={true}
        // />
        <InputField
          className="inputBox mt-1"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={!row.isManual} // ← enabled only for manual rows
        />
      ),
      sortable: false,
      width: "200px",
    },
    {
      name: "Schedule",
      selector: (row) => row.local_id || "--",
      sortable: false,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServicesLineItem(row.local_id, row.schedule, "SE")
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.schedule?.length || 0} </span>
        </>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: false,
      width: "200px",
    },
    /*   {
      name: "Material Group",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: false,
      width: "200px",
    }, */
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: false,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Unit Price ",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   name="netValue"
        //   placeholder=""
        //   value={row.netValue || 0}
        //   disabled={true}
        // />
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
          disabled={!row.isManual} // ← enabled only for manual rows
        />
      ),
      width: "130px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "200px",
    },
    {
      name: "GST Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   name="taxAmount"
        //   placeholder=""
        //   value={row.taxAmount || 0}
        //   disabled={true}
        // />
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount || 0}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
          disabled={true}
        />
      ),
      sortable: false,
      width: "200px",
    },
    {
      name: "GST Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: false,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    /*    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: false,
      width: "200px",
    }, */
    {
      name: "Godown",
      selector: (row) => row.storageLocation || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.storageLocation}</p>
        </div>
        // <InputField
        //   className="inputBox mt-1"
        //   // label="Please Enter the Remarks*"
        //   name="storageLocn"
        //   placeholder=""
        //   value={row.storageLocn || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        // />
      ),
      sortable: false,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: false,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let SchedulePOLineItemInitialData = [
    // {
    //   local_id: 1,
    //   purchasingDocumentItemNr: 1,
    //   itemTextData: [],
    //   statusItem: "In Release",
    //   currency: getCurrencyDropdown.name || "Rupee",
    //   currencyCode: getCurrencyDropdown.code || "INR",
    //   taxCode: 0,
    //   taxAmount: 0,
    // },
  ];

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  // const [isCardVisible5, setCardVisible5] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const [getDisabledStatus, setDisabledStatus] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");

  // const [loading, setLoading] = useState(false);
  const [getLineItemHeaderTextModal, setLineItemHeaderTextModal] =
    useState(false);
  const [getHeaderTextIndex, setHeaderTextIndex] = useState(0);
  const [HeaderTextModel, setHeaderTextModel] = useState(false);
  const [getDataToHeaderText, setDataToHeaderText] = useState([]);
  const [subTotalValue, setSubTotalValue] = useState(0);
  const [getTaxAmountValue, setTaxAmountValue] = useState(0);
  const [getItemAmountValue, setItemAmountValue] = useState(0);
  const [getPurchaseType, setPurchaseType] = useState(0);

  // const [getPurchaseCategory, setPurchaseCategory] = useState(0);
  // eslint-disable-next-line
  const [getMatchType, setMatchType] = useState(0);
  // const [getpurchaseGroup, setpurchaseGroup] = useState(0);

  //Services
  const [getServicesLineItemModal, setServicesLineItemModal] = useState(false);
  const [getServicesLineItemIndex, setServicesLineItemIndex] = useState(0);
  const [getServicesLineItemText, setServicesLineItemText] = useState([]);
  const [getServiceTitle, setServiceTitle] = useState("");

  // useEffect(()=>{

  // },[getServicesLineItemText])
  //Schedule
  // const [getScheduleLineItemModal, setScheduleLineItemModal] = useState(false);
  // const [getScheduleLineItemIndex, setScheduleLineItemIndex] = useState(0);
  // const [getScheduleLineItemText, setScheduleLineItemText] = useState([]);

  // Header Text
  const handleHeaderTextLineItemData = (data) => {
    setPOLineItemsData((prevUsers) =>
      prevUsers?.map((item) =>
        item.purchasingDocumentItemNr === getHeaderTextIndex
          ? { ...item, itemTextData: data }
          : item,
      ),
    );
  };

  const normalizeItemNr = (val) => String(val).padStart(3, "0");

  //Service PO and Schedule PO
  const handleServicePOLineItemData = (data = []) => {
    // console.log(">> incoming data", data);

    if (!Array.isArray(data)) return;

    setPOLineItemsData((prevUsers = []) =>
      prevUsers.map((item) => {
        if (
          normalizeItemNr(item.purchasingDocumentItemNr) !==
          normalizeItemNr(getServicesLineItemIndex)
        ) {
          return item;
        }

        // SERVICE PO
        if (formInputs.purchaseTypeCode === "SER") {
          let totalGrossValue = 0;
          let orderUnitOfMeasure = item.orderUnitOfMeasure;

          data.forEach((service) => {
            totalGrossValue += Number(service?.grossValue || 0);
            if (service?.orderUnitOfMeasure) {
              orderUnitOfMeasure = service.orderUnitOfMeasure;
            }
          });

          return {
            ...item,
            services: data,
            purchaseQuantity: 1,
            orderPriceUnit: totalGrossValue,
            orderUnitOfMeasure,
          };
        }

        return item;
      }),
    );
  };

  // const handleServicePOLineItemData = (data) => {
  //   console.log(">> data", data);

  //   // Validate that data is an array
  //   if (!Array.isArray(data)) {
  //     console.error("handleServicePOLineItemData: data is not an array", data);
  //     return;
  //   }

  //   if (formInputs.purchaseTypeCode === "SER") {
  //     let totalGrossValue = 0;
  //     let orderUnitOfMeasure = "";

  //     // Safe iteration with proper array
  //     data.forEach((item) => {
  //       totalGrossValue += Number(item?.grossValue || 0);
  //       orderUnitOfMeasure = item?.orderUnitOfMeasure || orderUnitOfMeasure;
  //     });

  //     setPOLineItemsData((prevUsers) =>
  //       prevUsers?.map((item) => {
  //         return item.purchasingDocumentItemNr === getServicesLineItemIndex
  //           ? {
  //               ...item,
  //               services: data,
  //               purchaseQuantity: 1,
  //               orderPriceUnit: totalGrossValue,
  //               orderUnitOfMeasure: orderUnitOfMeasure,
  //             }
  //           : item;
  //       })
  //     );
  //   } else {
  //     let totalScheduleQty = 0;

  //     // Safe iteration for schedule quantities
  //     data.forEach((item) => {
  //       totalScheduleQty += Number(item?.scheduleQuantity || 0);
  //     });

  //     setPOLineItemsData((prevUsers) =>
  //       prevUsers?.map((item) => {
  //         return item?.purchasingDocumentItemNr === getServicesLineItemIndex
  //           ? {
  //               ...item,
  //               schedule: data,
  //               purchaseQuantity: totalScheduleQty,
  //             }
  //           : item;
  //       })
  //     );
  //   }
  // };
  //   const handleServicePOLineItemData = (data) => {
  //     console.log(">> data", data);

  //     if (formInputs.purchaseTypeCode === "SER") {
  //       // let totalServiceQty = 0;
  //       let totalGrossValue = 0;
  //       let orderUnitOfMeasure = 0;

  //       data?.map((item) => {
  //         // totalServiceQty += Number(item.serviceQuantity);
  //         totalGrossValue += Number(item.grossValue);
  //         orderUnitOfMeasure = item.orderUnitOfMeasure;
  //         return "";
  //       });
  // // if (Array.isArray(data)) {
  // //   data.forEach((item) => {
  // //     totalGrossValue += Number(item?.grossValue || 0);
  // //     orderUnitOfMeasure = item?.orderUnitOfMeasure;
  // //   });
  // // }

  //       setPOLineItemsData((prevUsers) =>
  //         prevUsers?.map((item, index) => {
  //           return item.purchasingDocumentItemNr === getServicesLineItemIndex
  //             ? {
  //                 ...item,
  //                 services: data,
  //                 purchaseQuantity: 1,
  //                 orderPriceUnit: totalGrossValue,
  //                 orderUnitOfMeasure: orderUnitOfMeasure,
  //               }
  //             : item;
  //         })
  //       );
  //     } else {
  //       let totalScheduleQty = 0;

  // //       if (Array.isArray(data)) {
  // //   data.forEach((item) => {
  // //     totalScheduleQty += Number(item?.scheduleQuantity || 0);
  // //   });
  // // }

  //       setPOLineItemsData((prevUsers) =>
  //         prevUsers?.map((item) => {
  //           return item?.purchasingDocumentItemNr === getServicesLineItemIndex
  //             ? {
  //                 ...item,
  //                 schedule: data,
  //                 purchaseQuantity: totalScheduleQty,
  //               }
  //             : item;
  //         })
  //       );
  //     }
  //   };

  /* Header text selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);
  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
  };

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [disabled, setDisabled] = useState(false);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getPOLineItemsData, setPOLineItemsData] = useState(
    POLineItemInitialData,
  );
  // eslint-disable-next-line no-unused-vars
  const [getPOLineItemsCol, setPOLineItemsCol] = useState(POLineItemInitialCol);

  const [getVendorDropdownData, setVendorDropdownData] = useState([]);
  const [getVendorDropdown, setVendorDropdown] = useState([]);
  const [getPurchaseOrg, setPurchaseOrg] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);
  // eslint-disable-next-line
  const [getINCOTerms, setINCOTerms] = useState([]);
  const [getcurrency, setcurrency] = useState([]);
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  // eslint-disable-next-line
  const [getLdperdaypercentage, setLdperdaypercentage] = useState([]);
  // eslint-disable-next-line
  const [getLdApplicability, setLdApplicability] = useState([]);
  // eslint-disable-next-line
  const [getdownPaymentCategory, setdownPaymentCategory] = useState([]);
  // eslint-disable-next-line
  const [getmodeOfTransport, setmodeOfTransport] = useState([]);
  // eslint-disable-next-line
  const [getretention, setretention] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  // const toggleCardVisibility5 = () => {
  //   setCardVisible5(!isCardVisible5);
  // };

  /* Create PO Line Item Header Text Modal Function */
  // eslint-disable-next-line
  const showLineItemHeaderText = (index, data) => {
    setLineItemHeaderTextModal(true);
    setHeaderTextIndex(index);
    setDataToHeaderText(data);
  };
  const hideLineItemHeaderText = () => {
    setLineItemHeaderTextModal(false);
  };

  /* Create Header Text Modal Function */
  // eslint-disable-next-line
  const showsetHeaderText = () => {
    setHeaderTextModel(true);
    setDataToHeaderText();
  };
  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };
  // eslint-disable-next-line
  const HeaderTextColumns = [
    {
      name: "Code",
      cell: (row) => (
        <>
          <span>{row.documentId}</span>
        </>
      ),
      width: "30rem",
    },
    {
      name: "Text",
      cell: (row) => (
        <>
          <span>{row.documentText}</span>
        </>
      ),
      width: "30rem",
    },
    // {
    //   name: "Delete",
    //   cell: (row, index) => (
    //     <>
    //       <span>
    //         <i
    //           onClick={() => handleDelete(index)}
    //           className="bi bi-trash text-danger fs-3"
    //         ></i>
    //       </span>
    //     </>
    //   ),
    //   width: "10rem",
    // },
  ];

  /* Create Services PO Line Item Modal Function */
  const showServicesLineItem = (index, data, type) => {
    // console.log(">>linet item",index,data)
    setServicesLineItemModal(true);
    setServicesLineItemIndex(index);
    setServicesLineItemText(data);
    setServiceTitle(type === "SER" ? "Services List" : "Schedule List");
  };
  const hideServicesLineItem = () => {
    setServicesLineItemModal(false);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
  };

  // Get Dropdown data select
  useEffect(() => {
    // console.log(">>getDropdownData",getDropdownData)
    if (getDropdownData?.code === "SA") {
      // Schedule Agreement
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setPOLineItemsCol(SchedulePOLineItemInitialCol || []);
      setPOLineItemsData(SchedulePOLineItemInitialData || []);
    } else if (getDropdownData?.code === "SER") {
      // Service

      setFormInputs((prev) => ({
        ...prev,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        process: "",
        processCode: "",
        processDesc: "",
      }));

      setPOLineItemsCol(ServicePOLineItemInitialCol || []);
      setPOLineItemsData(ServicePOLineItemInitialData || []);
    } else if (getDropdownData?.textField === "companyCode") {
      // console.log(">>getDropdownData",getDropdownData)

      // Service
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.companyCode,
        [getDropdownData?.textCode]: getDropdownData?.companyCodeCode,
        [getDropdownData?.textDesc]: getDropdownData?.companyCodeDesc,
      }));
    } else if (getDropdownData?.textField === "vendorName") {
      // Service
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "purchaseOrderType") {
      // Service
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.code === "MAT") {
      setFormInputs((prev) => ({
        ...prev,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,

        ...(getDropdownData?.code === "MAT"
          ? {
              process: "GRN",
              processCode: "GRN",
              processDesc: "GRN",
            }
          : {
              process: "",
              processCode: "",
              processDesc: "",
            }),
      }));

      setPOLineItemsCol(POLineItemInitialCol || []);
      setPOLineItemsData(POLineItemInitialData || []);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;
    // console.log("handle change ",value,name)
    if (type === "Number" && (vat === undefined || vat === "UNITPRICE")) {
      if (isValidNumber(value)) {
        setPOLineItemsData((prevRows) =>
          prevRows?.map((row) => {
            // if (name === "purchaseQuantity") {
            //   const price = Number(row?.unitPrice || row.orderPriceUnit || 0);
            //   return row.local_id === local_id
            //     ? {
            //         ...row,
            //         [name]: value,
            //         netValue: price * Number(value),
            //         taxAmount:
            //           (Number(row.taxCode) / 100) * (price * Number(value)),
            //       }
            //     : row;
            // } else if (name === "orderPriceUnit" || name === "unitPrice") {
            //   const quantity = Number(row.purchaseQuantity || 0);
            //   return row.local_id === local_id
            //     ? {
            //         ...row,
            //         unitPrice: value,
            //         orderPriceUnit: value,
            //         netValue: quantity * Number(value),
            //         taxAmount:
            //           (Number(row.taxCode) / 100) * (quantity * Number(value)),
            //       }
            //     : row;
            // } else {
            //   return row.local_id === local_id
            //     ? {
            //         ...row,
            //         [name]: value,
            //       }
            //     : row;
            // }
            if (name === "purchaseQuantity") {
              const price = Number(row?.unitPrice || row.orderPriceUnit || 0);
              const net = Number((price * Number(value)).toFixed(2));
              return row.local_id === local_id
                ? {
                    ...row,
                    [name]: value,
                    netValue: net,
                    taxAmount: Number(
                      ((Number(row.taxCode) / 100) * net).toFixed(2),
                    ),
                  }
                : row;
            } else if (name === "orderPriceUnit" || name === "unitPrice") {
              // const quantity = Number(row.purchaseQuantity || 0);
              // const net = Number((quantity * Number(value)).toFixed(2));
              // return row.local_id === local_id
              //   ? {
              //       ...row,
              //       unitPrice: value,
              //       orderPriceUnit: value,
              //       netValue: net,
              //       taxAmount: Number(
              //         ((Number(row.taxCode) / 100) * net).toFixed(2),
              //       ),
              //     }
              //   : row;
              const quantity = Number(row.purchaseQuantity || 0);
              const storedPrice =
                value === "" || value === "." || value.endsWith(".")
                  ? value
                  : Number(value);
              const net = Number((quantity * Number(value || 0)).toFixed(2));
              return row.local_id === local_id
                ? {
                    ...row,
                    unitPrice: storedPrice,
                    orderPriceUnit: storedPrice,
                    netValue: net,
                    taxAmount: Number(
                      ((Number(row.taxCode) / 100) * net).toFixed(2),
                    ),
                  }
                : row;
            } else {
              return row.local_id === local_id
                ? { ...row, [name]: value }
                : row;
            }
          }),
        );
      }
    } else if (type === "Number" && vat === "VAT") {
      if (isValidNumber(value)) {
        setPOLineItemsData((prevRows) =>
          prevRows?.map((row) =>
            row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  // taxAmount:
                  //   name === "taxCode"
                  //     ? (Number(value) / 100) *
                  //       (Number(row.purchaseQuantity || 0) *
                  //         Number((row?.unitPrice ?? row.orderPriceUnit) || 0))
                  //     : 0,
                  taxAmount:
                    name === "taxCode"
                      ? Number(
                          (
                            (Number(value) / 100) *
                            (Number(row.purchaseQuantity || 0) *
                              Number(
                                (row?.unitPrice ?? row.orderPriceUnit) || 0,
                              ))
                          ).toFixed(2),
                        )
                      : 0,
                }
              : row,
          ),
        );
      }
    } else {
      setPOLineItemsData((prevRows) =>
        prevRows?.map((row) =>
          row.local_id === local_id ? { ...row, [name]: value } : row,
        ),
      );
    }
    // getTotalCount()
  };

  // Get Total for SubTotal Pricing Schedule

  useEffect(() => {
    // console.log(">> getPOLineItemsData", getPOLineItemsData);

    const getItemTotal = getPOLineItemsData?.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.netValue || 0),
      0,
    );
    const taxTotalAmount = getPOLineItemsData?.reduce(
      (acc, item) =>
        acc + Number(String(item?.taxAmount).replace(/,/g, "") || 0),
      0,
    );

    // setTaxAmountValue(taxTotalAmount);
    // setItemAmountValue(getItemTotal);

    // setSubTotalValue(Number(getItemTotal) + Number(taxTotalAmount));
    setTaxAmountValue(Number(taxTotalAmount.toFixed(2)));
    setItemAmountValue(Number(getItemTotal.toFixed(2)));
    setSubTotalValue(
      Number((Number(getItemTotal) + Number(taxTotalAmount)).toFixed(2)),
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPOLineItemsData]);
  // useEffect(() => {
  //   getvendorDetials(getVendorDropdown?.id);
  // }, [getVendorDropdown]);
  useEffect(() => {
    if (getVendorDropdown?.id) {
      getvendorDetials(getVendorDropdown?.id);
    }
  }, [getVendorDropdown]);

  useEffect(() => {
    getMasterDataFunc();

    loadInitialPageData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Load Master Data
  const getMasterDataFunc = async () => {
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });
    setDisabled(true);
    // 1
    let obj1 = {};
    await ItemService.getSupplierDatail(obj1).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setVendorDropdownData(item?.data);
      } else {
        setVendorDropdownData([]);
        console.log(">> Error: Loading getSupplierDatail");
      }
    });

    // 2
    let obj2 = {
      codeType: "purchaseOrganisation",
    };
    await ItemService.getMasterData(obj2).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setPurchaseOrg(item?.data);
      } else {
        setPurchaseOrg([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj3 = {
      // codeType: "companyCode",

      queryName: "Get_CompanyMaster_List",
      page: 1,
      per_page: 9999,
      searchTerm: "",
      timeZone: "Asia/Calcutta",
    };
    await ItemService.generateCustomerQuery(obj3).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj5 = {
      codeType: "currency",
    };
    await ItemService.getMasterData(obj5).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setcurrency(item?.data);
      } else {
        setcurrency([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj6 = {
      codeType: "paymentTerm",
    };
    await ItemService.getMasterData(obj6).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setpaymentTerm(item?.data);
      } else {
        setpaymentTerm([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj12 = {
      codeType: "PurchaseType",
    };
    await ItemService.getMasterData(obj12).then((item) => {
      if (item?.status === 200) {
        setPurchaseType(item?.data);
      } else {
        setPurchaseType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    setDisabled(false);
    toast.dismiss(toastId);
    // setLoader(false);
  };

  //all vedore
  const getvendorDetials = async (associateNumber) => {
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });
    setDisabled(true);

    try {
      let obj2 = {
        userId: associateNumber,
      };

      const item1 = await ItemService.getUserDetail(obj2);

      if (item1?.status === 200) {
        const selectedVendor = item1.data;

        if (selectedVendor) {
          const gstDoc =
            selectedVendor?.certifications?.find(
              (cert) =>
                cert?.documentType &&
                cert.documentType.split(" - ")[0] === "101",
            ) || null;

          setFormInputs((prev) => ({
            ...prev,
            vendorAddress:
              (selectedVendor?.address || "") +
              " " +
              (selectedVendor?.address2 || "") +
              " " +
              (selectedVendor?.city || "") +
              " - " +
              (selectedVendor?.cityPostalCode || ""),
            vendorEmail: selectedVendor.email,
            vendorMobileNo: selectedVendor.mobileNr,
            vendorGSTNo: gstDoc?.documentNumber || "",
          }));
        }
      } else {
        console.log(">> Error: Loading getSupplierDetail");
      }
    } catch (error) {
      console.error(">> API Error:", error);
    }

    toast.dismiss(toastId);
    setDisabled(false);
  };

  // SAVE
  const handleUpdate = async (newRemarks) => {
    let requiredFields = [];

    // if (!validateRequired(getVendorDropdown.firstName)) {
    //   requiredFields.push("*Please Select the Vendor");
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }
    if (!validateRequired(formInputs.paymentTerms)) {
      requiredFields.push("*Please Select the Payment Terms");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    if (!validateRequired(formInputs.purchaseType)) {
      requiredFields.push("*Please Select the Purchase Type");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    if (formInputs?.purchaseTypeCode === "SER") {
      const allHaveServices = getPOLineItemsData.every(
        (item) => Array.isArray(item.services) && item.services.length > 0,
      );

      if (!allHaveServices) {
        return toast.error(
          "At least add one Service for each Price Shedule / Line Item",
          {
            position: "top-right",
            autoClose: 5000,
          },
        );
      }
    }

    // if (
    //   typeof getPOLineItemsData[0]?.materialCode === "undefined" ||
    //   typeof getPOLineItemsData[0]?.purchaseQuantity === "undefined" ||
    //   typeof getPOLineItemsData[0]?.orderUnitOfMeasure === "undefined" ||
    //   typeof getPOLineItemsData[0]?.orderPriceUnit === "undefined" ||
    //   typeof getPOLineItemsData[0]?.deliveryDate === "undefined"
    // ) {
    //   requiredFields.push("*Alteast one PO Line item should be added.");
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }
    const incrementVersion = (version) => {
      // remove 'V' and convert to number
      const num = parseInt(version.replace("V", ""), 10);

      // increment and return with V prefix
      return `V${num + 1}`;
    };

    // let lineItem = []
    formInputs.items = getPOLineItemsData;
    formInputs.vendorCode = getVendorDropdown.id;
    formInputs.vendorName = getVendorDropdown.firstName;
    formInputs.headerTextData = getHeaderTextSelectedData;
    formInputs.purchasingDocumentValue = subTotalValue;
    formInputs.purchasingDocumentTaxTotalValue = getTaxAmountValue;
    formInputs.purchasingDocumentItemTotalValue = getItemAmountValue;
    formInputs.currencyCode = getCurrencyDropdown.code;
    formInputs.currency = getCurrencyDropdown.codeType;
    formInputs.currencyDesc = getCurrencyDropdown.name;
    formInputs.updateRemarks = newRemarks;
    formInputs.status = "registerd";
    formInputs.statusHeader = "PO Revised";
    formInputs.version = incrementVersion(formInputs.version);

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    // let obj = {
    //   ...formInputs,
    //   documentNumber: poNumber,
    //   purchasingDocumentNr: poNumber,
    // };
    const { _id, ...cleanFormInputs } = formInputs;

    const cleanItems = (formInputs.items || []).map((it) => {
      const { _id, ...rest } = it;
      return rest;
    });

    cleanFormInputs.items = cleanItems;

    let obj = {
      ...cleanFormInputs,
      documentNumber: poNumber,
      purchasingDocumentNr: poNumber,
    };

    // console.log(">>obj",obj)

    setDisabled(true);
    await CustomerService.updatePODocs(obj).then((item) => {
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();

        let materialPO = {
          queryName: "getMaterialPO",
          module: "PO",
        };
        let servicePO = {
          queryName: "getServicePO",
          module: "PO",
        };
        let schedulingAgreement = {
          queryName: "getSchedulingAgreement",
          module: "PO",
        };

        if (formInputs.purchaseTypeCode === "MAT") {
          dispatch(getPurchaseOrder(materialPO));
        } else if (formInputs.purchaseTypeCode === "SER") {
          dispatch(getServicePO(servicePO));
        } else if (formInputs.purchaseTypeCode === "SA") {
          dispatch(getSchedulingAgreement(schedulingAgreement));
        }
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  // eslint-disable-next-line
  const addPOItemRow = () => {
    setPOLineItemsData((prevRows) => {
      POLineItemInitialData[0].local_id = prevRows.length + 1;
      POLineItemInitialData[0].purchasingDocumentItemNr = prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...POLineItemInitialData];
    });
  };

  const addManualPO = () => {
    setPOLineItemsData((prevRows) => {
      const newRow = {
        local_id: prevRows.length + 1,
        purchasingDocumentItemNr: String(prevRows.length + 1).padStart(3, "0"),
        itemTextData: [],
        statusItem: "In Release",
        currency: "Rupee",
        currencyCode: "INR",
        materialCode: "",
        materialDescription: "",
        materialGroup: "",
        purchaseQuantity: "",
        orderUnitOfMeasure: "",
        orderPriceUnit: "",
        unitPrice: "",
        netValue: 0,
        deliveryDate: "",
        itemCurrency: "",
        plant: "",
        storageLocation: "Sale", // default
        storageLocn: "Sale", // default
        taxCode: 0,
        taxAmount: 0,
        buyBack: false,
        buyBackItem: formInputs.buyBack || false,
        services: [],
        schedule: [],
        isManual: true, // flag to identify manual rows
      };

      return [...prevRows, newRow];
    });
  };

  const removePOItemRow = (local_id) => {
    setPOLineItemsData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id),
    );
  };
  //material selection
  const [modalShow, setModalShow] = useState(false);

  /* Modal Function */
  const addProductDetails = () => {
    setModalShow(true);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const handleGetSelectedMaterial = (selectedData) => {
    // console.log(">>selectedData",selectedData)
    if (!Array.isArray(selectedData) || selectedData.length === 0) return;

    setPOLineItemsData((prevRows) => {
      const startIndex = prevRows.length;

      const mappedRows = selectedData.map((item, index) => ({
        ...item,
        local_id: startIndex + index + 1,
        purchasingDocumentItemNr: String(startIndex + index + 1).padStart(
          3,
          "0",
        ),
      }));

      return [...prevRows, ...mappedRows];
    });
  };
  //load intial data
  const loadInitialPageData = async () => {
    // setLoading(true);
    if (poNumber) {
      let obj = {
        documentNumber: poNumber,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.getPurchaseOrderDetail(obj).then((item) => {
        if (item?.status === 200) {
          const data = item?.data || {};

          // setHeaderData(item?.data);
          const { _id, ...restFormInputs } = data;
          const cleanedItems = (data.items || []).map((i) => {
            const { _id, ...rest } = i;
            return rest;
          });
          setFormInputs(restFormInputs);
          setPOLineItemsData(cleanedItems);
          // setFormInputs(item?.data);
          // setPOLineItemsData(item?.data?.items);

          // dispatch(addPoSelectedDetails(item?.data));
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });

      // setLoading(false);
    } else {
      window.history.back();
    }
  };

  const TrasnportUpdate = () => {
    setEditMode(false);
  };
  const cancelUpdate = () => {
    setEditMode(true);
  };
  const convertToISO = (d) => {
    if (!d) return ""; // or return null based on your requirement

    // if d is already in YYYY-MM-DD format
    if (d.includes("-") && d.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return d;
    }

    const [day, month, year] = d.split("-");
    return `${year}-${month}-${day}`;
  };

  //update remarsk modal
  const showApproveModal = async (name) => {
    setUpdateModalShow(true);
  };
  const updateHideModal = () => {
    setUpdateModalShow(false);
  };

  const handleValueChange = (remarks) => {
    const incrementVersion = (version) => {
      // remove 'V' and convert to number
      const num = parseInt(version.replace("V", ""), 10);
      // increment and return with V prefix
      return `V${num + 1}`;
    };

    const version = incrementVersion(formInputs.version);

    const newRemarks = [
      ...(formInputs.updateRemarks || []),
      { remark: remarks, version: version, status: "Po Pending" },
    ];

    setFormInputs((prev) => ({
      ...prev,
      updateRemarks: newRemarks,
    }));

    handleUpdate(newRemarks);
  };

  //version
  const remarkLineItemColInfo = [
    {
      name: "Remarks",
      cell: (row) => <span>{row?.remark || ""} </span>,
      width: "180px",
    },
    {
      name: "Version",
      cell: (row) => <span>{row?.version || ""} </span>,
      width: "180px",
    },
    {
      name: "Status",
      cell: (row) => (
        <span>
          {" "}
          <TableStatusField status={row?.status} />
        </span>
      ),
      width: "180px",
    },
  ];
  const remarkItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(remarkLineItemColInfo);
    setModalTitle("PO Remarks / Version");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Upadte Purchase Document</h2>
            <p className="subText">Update Purchase Document Details</p>
            <hr />
            <Loader isLoading={getLoader} className={"text-center"} />

            {!getLoader && (
              <>
                <Row className="mb-4">
                  {/* edit button */}
                  {editMode && (
                    <Col
                      xs={6}
                      md={{ span: 2, offset: 10 }}
                      lg={{ span: 2, offset: 10 }}
                      className="text-left"
                    >
                      {/* {hasAccess(
                                userRole,
                                "buttons",
                                "customer_details_edit",
                                pageConfigInfo
                              ) && ( */}
                      <Col xs={6} md={2} lg={2} className="text-left">
                        <button
                          className="btn btnInfo"
                          disabled={disabled}
                          onClick={TrasnportUpdate}
                        >
                          Edit
                        </button>
                      </Col>
                      {/* )} */}
                    </Col>
                  )}
                  {!editMode && (
                    <Col
                      xs={6}
                      md={{ span: 2, offset: 8 }}
                      lg={{ span: 2, offset: 8 }}
                      className="text-left "
                      // onClick={handleUpdate}
                      onClick={() => showApproveModal("Update")}
                    >
                      <button className="btn btnInfo" disabled={disabled}>
                        Update
                      </button>
                    </Col>
                  )}
                  {!editMode && (
                    <Col xs={6} md={2} lg={2} className="text-left">
                      <button
                        className="btnInfo btn-danger"
                        onClick={cancelUpdate}
                      >
                        Cancel
                      </button>
                    </Col>
                  )}
                </Row>
                {/*Document Header Details */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">HD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Header Details</span>
                          <span className="subHeaderTitle">
                            Document Description and Details{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col> */}
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentType"
                              className="inputBox"
                              label="Document type"
                              name="purchasingDocumentType"
                              code="purchasingDocumentTypeCode"
                              description="purchasingDocumentTypeDesc"
                              placeholder=""
                              value={formInputs?.purchasingDocumentType} // purchasingDocumentType
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentDate"
                              className="inputBox"
                              label="Document Date"
                              name="purchasingDocumentDate"
                              placeholder=""
                              type="date"
                              value={convertToISO(
                                formInputs?.purchasingDocumentDate,
                              )}
                              onChange={onInputChange}
                              disabled={editMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="statusHeader"
                              className="inputBox"
                              label="Status"
                              name="statusHeader"
                              placeholder=""
                              value={formInputs?.statusHeader}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Purchase Organization"
                              extraLabel="SAP Purchase organization"
                              placeholder=""
                              data={getPurchaseOrg}
                              id="purchasingOrg"
                              iconClassName="dropdownIcon"
                              name="purchasingOrg"
                              code="purchasingOrgCode"
                              description="purchasingOrgDesc"
                              setValue={formInputs?.purchasingOrg || []}
                              getvalue={setDropdownData}
                              disabled={editMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Company Code"
                              extraLabel="SAP Company Code"
                              placeholder=""
                              data={getCompanyCode}
                              id="companyCode"
                              iconClassName="dropdownIcon"
                              name="companyCode"
                              code="companyCodeCode"
                              description="companyCodeDesc"
                              setValue={formInputs?.companyCode || []}
                              getvalue={setDropdownData}
                              disabled={editMode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="purchaseType"
                              label="Purchase Type"
                              placeholder=""
                              data={getPurchaseType}
                              iconClassName="dropdownIcon"
                              name="purchaseType"
                              code="purchaseTypeCode"
                              description="purchaseTypeDesc"
                              setValue={formInputs?.purchaseType || []}
                              getvalue={setDropdownData}
                              disabled={true}
                              // required={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="purchaseOrderType"
                              label="Purchase Order Type"
                              placeholder=""
                              data={getPurchaseOrderType}
                              iconClassName="dropdownIcon"
                              name="purchaseOrderType"
                              code="purchaseOrderTypeCode"
                              description="purchaseOrderTypeDesc"
                              setValue={formInputs?.purchaseOrderType || ""}
                              getvalue={setDropdownData}
                              disabled={editMode}
                              // required={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            {/* Diff logic for this Only */}
                            <ComboboxField
                              className="dropdownOption"
                              label="Vendor"
                              placeholder=""
                              data={getVendorDropdownData}
                              id="vendorName"
                              iconClassName="dropdownIcon"
                              name="vendorName"
                              setValue={
                                getVendorDropdown?.name ||
                                formInputs?.vendorName ||
                                ""
                              }
                              getvalue={setVendorDropdown}
                              disabled={editMode}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="vendorAddress"
                              className="inputBox"
                              label="Vendor Address"
                              name="vendorAddress"
                              placeholder=""
                              value={formInputs?.vendorAddress || ""}
                              disabled={true}
                              // onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="vendorEmail"
                              className="inputBox"
                              label="Vendor Email"
                              name="vendorEmail"
                              placeholder=""
                              value={formInputs?.vendorEmail || ""}
                              disabled={true}
                              // onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="vendorMobileNo"
                              className="inputBox"
                              label="Vendor Mobile"
                              name="vendorMobileNo"
                              placeholder=""
                              value={formInputs?.vendorMobileNo || ""}
                              disabled={true}
                              // onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="vendorGSTNo"
                              className="inputBox"
                              label="Vendor GST"
                              name="vendorGSTNo"
                              placeholder=""
                              value={formInputs?.vendorGSTNo || ""}
                              disabled={true}
                              // onChange={onInputChange}
                            />
                          </Col>

                          {/*  <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Purchase Group"
                              name="purchasingGroup"
                              data={getpurchaseGroup}
                              id="purchasingGroup"
                              code="purchasingGroupCode"
                              description="purchasingGroupDesc"
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.purchasingGroup || []}
                              getvalue={setDropdownData}
                              placeholder=""
                              disabled={getDisabledStatus}
                            />
                          </Col> */}

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Payment Terms"
                              extraLabel=""
                              placeholder=""
                              data={getpaymentTerm}
                              id="paymentTerms"
                              iconClassName="dropdownIcon"
                              name="paymentTerms"
                              code="paymentTermsCode"
                              description="paymentTermsDesc"
                              setValue={formInputs?.paymentTerms || []}
                              getvalue={setDropdownData}
                              disabled={editMode}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="INCOTerms"
                              extraLabel="INCOTerms Code"
                              placeholder=""
                              data={getINCOTerms}
                              id="incoTerms"
                              iconClassName="dropdownIcon"
                              name="incoTerms"
                              code="incoTermsCode"
                              description="incoTermsDesc"
                              setValue={formInputs?.incoTerms || []}
                              getvalue={setDropdownData}
                            />
                          </Col> */}

                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="incoTermsLocation"
                              className="inputBox"
                              label="INCOTerms Location"
                              name="incoTermsLocation"
                              placeholder=""
                              value={formInputs.incoTermsLocation}
                              onChange={onInputChange}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentValue"
                              className="inputBox"
                              label="Total Item Amount"
                              name="purchasingDocumentValue"
                              placeholder=""
                              value={getItemAmountValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentValue"
                              className="inputBox"
                              label="Total GST Amount"
                              name="purchasingDocumentValue"
                              placeholder=""
                              value={getTaxAmountValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentValue"
                              className="inputBox"
                              label="Total Purchase Value"
                              name="purchasingDocumentValue"
                              placeholder=""
                              value={subTotalValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Currency"
                              placeholder=""
                              data={getcurrency}
                              id="currency"
                              iconClassName="dropdownIcon"
                              name="currency"
                              code="currencyCode"
                              description="currencyDesc"
                              setValue={
                                getCurrencyDropdown?.name || {
                                  code: "INR",
                                  name: "INR-Rupee",
                                }
                              }
                              getvalue={setCurrencyDropdown}
                              disabled={true}
                            />
                          </Col>
                          {/*         <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="exchangeRate"
                              className="inputBox"
                              label="Exchange Rate"
                              name="exchangeRate"
                              placeholder=""
                              value={formInputs.exchangeRate}
                              onChange={onInputChange}
                            />
                          </Col> */}
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Exchange Rate"
                              name="firstName"
                              placeholder=""
                              // value={""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col> */}

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="purchasingRemark"
                              className="inputBox"
                              label="Purchasing Info"
                              name="purchasingRemark"
                              placeholder=""
                              value={formInputs?.purchasingRemark || ""}
                              onChange={onInputChange}
                              disabled={editMode}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="version"
                              className="inputBox"
                              label="Version"
                              name="version"
                              placeholder=""
                              value={formInputs?.version || ""}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          {formInputs?.purchaseTypeCode === "MAT" && (
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <span className="fw-medium text-black">
                                PO Remarks / Version
                              </span>
                              <div>
                                <span
                                  style={{ marginLeft: "12px" }}
                                  onClick={() =>
                                    remarkItemShowModal(
                                      formInputs.updateRemarks,
                                    )
                                  }
                                >
                                  <i className="bi bi-calendar2-week iconTable"></i>
                                </span>
                                <span className="suppliersIcon">
                                  {formInputs?.updateRemarks?.length > 0
                                    ? `${formInputs.updateRemarks.length}/${formInputs?.version}`
                                    : `0/${formInputs?.version}`}
                                </span>
                              </div>
                            </Col>
                          )}
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding  d-flex align-items-center"
                            >
                              <input
                                id="deliveryLoaction"
                                type="checkbox"
                                className="inputBox"
                                label="Delivery Location"
                                name="deliveryLoaction"
                                checked={formInputs?.deliveryLoaction ?? true}
                                onChange={(e) =>
                                  setFormInputs((prev) => ({
                                    ...prev,
                                    deliveryLoaction: e.target.checked,
                                  }))
                                }
                                disabled={editMode}
                              />
                              <label
                                htmlFor="deliveryLoaction"
                                className="fw-medium mx-2"
                                style={{ cursor: "pointer" }}
                              >
                                Delivery Location
                              </label>
                            </Col>
                          </Row>
                          {formInputs?.deliveryLoaction && (
                            <Row>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <TextAreaField
                                  id="addressDl"
                                  className="inputBox"
                                  label="Address"
                                  name="addressDl"
                                  placeholder=""
                                  value={formInputs?.addressDl}
                                  onChange={onInputChange}
                                  disabled={editMode}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  id="mobileNoDl"
                                  className="inputBox"
                                  label="Mobile No"
                                  name="mobileNoDl"
                                  placeholder=""
                                  value={formInputs?.mobileNoDl}
                                  onChange={onInputChange}
                                  disabled={editMode}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  id="gstInDl"
                                  className="inputBox"
                                  label="GSTIN"
                                  name="gstInDl"
                                  placeholder=""
                                  value={formInputs?.gstInDl}
                                  onChange={onInputChange}
                                  disabled={editMode}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  id="emailDl"
                                  className="inputBox"
                                  label="Email"
                                  name="emailDl"
                                  placeholder=""
                                  value={formInputs?.emailDl}
                                  onChange={onInputChange}
                                  disabled={editMode}
                                />
                              </Col>
                            </Row>
                          )}
                          {formInputs?.purchaseType === "MAT - Material" && (
                            <>
                              {/*    <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Process"
                                id="process"
                                data={processOptions}
                                placeholder=""
                                value={formInputs.process || ""}
                                name="process"
                                code="processCode"
                                description="processDesc"
                                setValue={formInputs?.process || []}
                                getvalue={setDropdownData}                                
                                disabled={getDisabledStatus}
                              />
                            </Col> */}
                              {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="match"
                              label="Match"
                              placeholder=""
                              data={getMatchType}
                              iconClassName="dropdownIcon"
                              name="match"
                              code="matchCode"
                              description="matchDesc"
                              setValue={formInputs?.match || []}
                              getvalue={setDropdownData}
                              disabled={false}
                            />
                          </Col> */}
                            </>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* other  charges table */}
                {/*   <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible5
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility5}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">DT</span>
                        </Col>

                        <Col xs={4} md={3} lg={3}>
                          <span className="headerTitle">Document Texts</span>
                          <span className="subHeaderTitle">
                            Document texts and Specification{" "}
                          </span>
                        </Col>
                        <Col
                          xs={12}
                          md={8}
                          lg={8}
                          className="headerButtonAlign"
                        >
                          <Col xs={4} md={2} lg={2} className="">
                            <button
                              className="btnTable"
                              onClick={showsetHeaderText}
                            >
                              <i className="bi bi-plus-lg"></i> Add
                            </button>
                          </Col>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible5 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              // title=""
                              columns={HeaderTextColumns}
                              data={getHeaderTextSelectedData}
                              // progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/*quotation Header */}
                {/*  <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">AC</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">
                            Additional Context
                          </span>
                          <span className="subHeaderTitle">
                            {" "}
                            Additional Document details
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col>
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="LD-Applicability"
                              extraLabel=""
                              placeholder=""
                              data={getLdApplicability}
                              id="ldApplicability"
                              iconClassName="dropdownIcon"
                              name="ldApplicability"
                              code="ldApplicabilityCode"
                              setValue={formInputs?.ldApplicability || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="LD Per Day in %"
                              extraLabel=""
                              placeholder=""
                              data={getLdperdaypercentage}
                              id="ldPerDayInPercentage"
                              iconClassName="dropdownIcon"
                              name="ldPerDayInPercentage"
                              code="ldPerDayInPercentageCode"
                              setValue={formInputs?.ldPerDayInPercentage || []}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Down Payment Category"
                              extraLabel=""
                              placeholder=""
                              data={getdownPaymentCategory}
                              id="downPaymentIndicator"
                              iconClassName="dropdownIcon"
                              name="downPaymentIndicator"
                              code="downPaymentIndicatorCode"
                              setValue={formInputs?.downPaymentIndicator || []}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="downPaymentPercentage"
                              className="inputBox"
                              label="Down Payment%"
                              name="downPaymentPercentage"
                              placeholder=""
                              value={formInputs.downPaymentPercentage}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="dueDateForDownPayment"
                              className="inputBox"
                              label="Down Payment Due Date"
                              name="dueDateForDownPayment"
                              placeholder=""
                              type="date"
                              value={formInputs.dueDateForDownPayment}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Mode of Transport"
                              extraLabel=""
                              placeholder=""
                              data={getmodeOfTransport}
                              id="modeOfTransport"
                              iconClassName="dropdownIcon"
                              name="modeOfTransport"
                              code="modeOfTransportCode"
                              setValue={formInputs?.modeOfTransport || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Retention"
                              extraLabel=""
                              placeholder=""
                              data={getretention}
                              id="retention"
                              iconClassName="dropdownIcon"
                              name="retention"
                              code="retentionCode"
                              setValue={formInputs?.retention || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Cost Centre"
                              extraLabel=""
                              placeholder=""
                              data={getretention}
                              id="costCentre"
                              iconClassName="dropdownIcon"
                              name="costCentre"
                              code="costCentreCode"
                              setValue={formInputs?.costCentre || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* Price Shedule / Line Item */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PS</span>
                        </Col>
                        <Col xs={12} md={3} lg={3}>
                          <span className="headerTitle">Price Schedule</span>
                          <span className="subHeaderTitle">
                            Price Shedule / Line Item
                          </span>
                        </Col>

                        <Col
                          xs={12}
                          md={8}
                          lg={8}
                          className="headerButtonAlign"
                        >
                          {/* <Col xs={4} md={2} lg={2} className="">
                            <button className="btnTable">
                              <i className="bi bi-file-excel"></i> Template
                            </button>
                          </Col>
                          <Col xs={4} md={2} lg={2} className="">
                            <button
                              className="btnTable"
                              onClick={() => {
                                alert("asd");
                              }}
                            >
                              <i className="bi bi-file-excel"></i> Upload
                            </button>
                          </Col> */}
                          {!editMode && (
                            <>
                              <Col xs={4} md={2} lg={2} className="">
                                <button
                                  className="btnTable"
                                  /* onClick={addPOItemRow} */ /* this manual enter */
                                  onClick={addProductDetails} // bring from data
                                >
                                  <i className="bi bi-plus-lg"></i> Add
                                </button>
                              </Col>
                              {formInputs?.purchaseTypeCode === "MAT" && (
                                <Col xs={4} md={2} lg={2} className="">
                                  <button
                                    className="btnTable"
                                    onClick={addManualPO}
                                  >
                                    Add Manual
                                  </button>
                                </Col>
                              )}
                            </>
                          )}
                        </Col>
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        {" "}
                        {/* dynamicDropdown */}
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              keyField="local_id"
                              title=""
                              columns={getPOLineItemsCol}
                              data={getPOLineItemsData}
                              // progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                              // onSelectedRowsChange={handleChange}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
      {!getLoader && (
        <>
          <div className="pageFooter mb-4">
            <Row className="rowDirection">
              {/* <Col xs={12} md={2} lg={2} className="pb-2">
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-save"></i> Create
                </button>
              </Col> */}
              {/* <Col xs={12} md={2} lg={2} className="">
                <button
                  className="btnTable"
                  //  onClick={handleModify}
                >
                  <i className="bi bi-pencil-square"></i> Modify
                </button>
              </Col> */}
            </Row>
          </div>
        </>
      )}

      {/* Header Text */}
      <HeaderText
        index={0}
        headername="Header Text"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="POHeaderTextID"
      />

      {/* Price Shedule / Line Item */}
      <HeaderText
        index={getHeaderTextIndex}
        headername="Header Text for Line Item"
        show={getLineItemHeaderTextModal}
        onHide={hideLineItemHeaderText}
        hedertextdata={handleHeaderTextLineItemData}
        showcurrentdata={getDataToHeaderText}
        masterdata="POItemTextID"
      />

      {/* Price Shedule -> Service PO */}
      {/* <SericesSchedulePO
        index={getServicesLineItemIndex}
        headername={getServiceTitle}
        show={getServicesLineItemModal}
        onHide={hideServicesLineItem}
        servicescheduledata={handleServicePOLineItemData}
        showcurrentdata={getServicesLineItemText}
        purchasetype={formInputs?.purchaseTypeCode}
      /> */}
      <SericesSchedulePOV5Modal
        index={getServicesLineItemIndex}
        headername={getServiceTitle}
        show={getServicesLineItemModal}
        onHide={hideServicesLineItem}
        servicescheduledata={handleServicePOLineItemData}
        showcurrentdata={getServicesLineItemText}
        purchasetype={formInputs?.purchaseTypeCode}
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={
          formInputs?.purchaseTypeCode === "MAT"
            ? Constants?.CUSTOMER_V5_PURCHASE_ORDER_LIST
            : formInputs?.purchaseTypeCode === "SER"
              ? Constants?.CUSTOMER_V5_MR_POCOLLABRATION_SERVICE_PURCHASE_ORDER_LIST
              : formInputs?.purchaseTypeCode === "SA"
                ? Constants?.POCOLLABRATION_SCHEDULING_AGREEMENT
                : ""
        }
      />
      <MaterialSelectionModalV5
        show={modalShow}
        onHide={() => hideModal()}
        onselectedcatdata={handleGetSelectedMaterial}
      />
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <UpdateRemarksModal
        show={updateModalShow}
        onHide={() => updateHideModal()}
        onvaluechange={handleValueChange}
      />
    </main>
  );
};

export default POUpdateV5;
